import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
} from "@mui/material";
import PreviewIcon from "@mui/icons-material/Preview";
import CloseIcon from "@mui/icons-material/Close";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import "./verticalStyling.css";
import {
  getDirectionImage,
  getDisruptionAssetSrc,
} from "../../helper/disruptionHelper";

const VerticalPreview = ({ fullWidth, previewType, disabled, createData }) => {
  const { t } = useTranslation("smrtDisruption");
  const { t: tCommon } = useTranslation();
  const { disruptions } = useSelector((state) => state.smrtDisruption);
  const [open, setOpen] = useState(false);
  const [order, setOrder] = useState(0);
  const [disruptionData, setDisruptionData] = useState([]);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (open === true) {
      setDisruptionData(previewType === "CREATE" ? createData() : disruptions);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const nextSlide = () => {
    const isLast = disruptionData.length === order + 1;
    setOrder(isLast ? 0 : order + 1);
  };
  const prevSlide = () => {
    const isFirst = order === 0;
    setOrder(isFirst ? disruptionData.length - 1 : order - 1);
  };

  return (
    <>
      <Button
        startIcon={<PreviewIcon fontSize="small" />}
        variant="contained"
        fullWidth={fullWidth}
        sx={{ boxShadow: 3 }}
        onClick={handleOpen}
        disabled={
          disabled || (disruptions?.length === 0 && previewType === "ALL")
        }
      >
        {t("preview.previewBtn")}
      </Button>

      <Dialog open={open} maxWidth={"xl"}>
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          {t("preview.previewTitle")}
          <IconButton onClick={handleClose}>
            <CloseIcon fontSize="small" color="inherit" />
          </IconButton>
        </DialogTitle>
        <Divider />
        <DialogContent>
          <>
            <Box
              //DS Display have aspect ratio of 9:16
              // 1080x1920 resolution
              sx={{
                width: "100%",
                maxWidth: 1080,
                aspectRatio: "9 / 16",
                mx: "auto",
              }}
            >
              <PreviewVertical disruptions={disruptionData} order={order} />
            </Box>
          </>
        </DialogContent>
        <DialogActions>
          <Box width={"100%"} display={"flex"} flexDirection={"column"}>
            <Box sx={{ mb: 2 }} display={"flex"} justifyContent={"center"}>
              <Button
                variant="contained"
                onClick={() => {
                  prevSlide();
                }}
              >
                {t("preview.backBtn")}
              </Button>

              <Box sx={{ mx: 2 }}></Box>

              <Button
                variant="contained"
                onClick={() => {
                  nextSlide();
                }}
              >
                {t("preview.nextBtn")}
              </Button>
            </Box>
            <Button fullWidth variant="outlined" onClick={handleClose}>
              {tCommon("closeBtn")}
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </>
  );
};

const PreviewVertical = ({ disruptions, order }) => {
  const uniArrowRight = "►";
  const uniArrowLeft = "◄";
  const lineColorConfig = {
    CAL: {
      color: "#009c4b",
      contrastText: "#ffffff",
      firstStation: "",
      lastStation: "",
    },
    CCL: {
      color: "#f99c25",
      contrastText: "#000000",
      firstStation: "Dhoby Ghaut",
      lastStation: "Harbour Front",
    },
    CCLE: {
      color: "#f99c25",
      contrastText: "#000000",
      firstStation: "",
      lastStation: "",
    },
    DTL: {
      color: "#005bc0",
      contrastText: "#ffffff",
      firstStation: "Bukit Panjang",
      lastStation: "Expo",
    },
    EWL: {
      color: "#009c4b",
      contrastText: "#ffffff",
      firstStation: "Pasir Ris",
      lastStation: "Tuas Link",
    },
    NEL: {
      color: "#8e3494",
      contrastText: "#ffffff",
      firstStation: "Harbour Front",
      lastStation: "Punggol Coast",
    },
    NSL: {
      color: "#e02725",
      contrastText: "#ffffff",
      firstStation: "Jurong East",
      lastStation: "Marina South Pier",
    },
    TEL: {
      color: "#bb5117",
      contrastText: "#ffffff",
      firstStation: "Woodlands North",
      lastStation: "Bayshore",
    },
    LRT: {
      color: "#5c6367",
      contrastText: "#ffffff",
      firstStation: "",
      lastStation: "",
    },
  };

  return (
    <Box id="splide-container" className="vert_mainframe-container">
      <Box className="vert_disruption__top-container">
        <Box className="vert_disruption__top-title-container">
          <Box>Train Service</Box>
          <Box>Disruption</Box>
        </Box>
        <Box
          className="vert_disruption__line-text-container"
          sx={{
            backgroundColor:
              lineColorConfig[
                disruptions[order].line.code.includes("LRT")
                  ? "LRT"
                  : disruptions[order].line.code
              ].color,
            color:
              lineColorConfig[
                disruptions[order].line.code.includes("LRT")
                  ? "LRT"
                  : disruptions[order].line.code
              ].contrastText,
          }}
        >
          {disruptions[order].line.name +
            " (" +
            disruptions[order].line.code +
            ")"}
        </Box>
        <Box className="vert_disruption__top-text-container">
          Please use alternative travel options to continue your journey
        </Box>
      </Box>
      <Box className="vert_disruption__middle-container">
        <Box sx={{ width: "100%" }}>
          <Box sx={{ width: "100%" }}>
            <Box className="vert_text-toward-container">
              {disruptions[order].direction === "sector"
                ? `Towards ${
                    +disruptions[order].toStation.order >=
                    +disruptions[order].fromStation.order
                      ? lineColorConfig[
                          disruptions[order].line.code.includes("LRT")
                            ? "LRT"
                            : disruptions[order].line.code
                        ].lastStation
                      : lineColorConfig[
                          disruptions[order].line.code.includes("LRT")
                            ? "LRT"
                            : disruptions[order].line.code
                        ].firstStation
                  } ${uniArrowRight}`
                : ""}
            </Box>
            <Box className="vert_disruption__line-image-container">
              <img
                src={getDisruptionAssetSrc(
                  disruptions[order].fromStation.abbreviation +
                    "-" +
                    disruptions[order].fromStation.code +
                    "-L.png",
                )}
                alt={disruptions[order].fromStation.name}
              />
              <img
                src={getDisruptionAssetSrc(
                  getDirectionImage(
                    disruptions[order].direction,
                    disruptions[order].type,
                    disruptions[order].isAffectingAllStation,
                  ),
                )}
                alt={getDirectionImage(disruptions[order].direction)}
              />
              <img
                src={getDisruptionAssetSrc(
                  disruptions[order].toStation.abbreviation +
                    "-" +
                    disruptions[order].toStation.code +
                    "-L.png",
                )}
                alt={disruptions[order].toStation.name}
              />
            </Box>
          </Box>

          {disruptions[order].direction === "sector" && (
            <Box sx={{ width: "100%" }}>
              <Box className="vert_text-toward-container">
                {`${uniArrowLeft} Towards ${
                  +disruptions[order].toStation.order >=
                  +disruptions[order].fromStation.order
                    ? lineColorConfig[
                        disruptions[order].line.code.includes("LRT")
                          ? "LRT"
                          : disruptions[order].line.code
                      ].firstStation
                    : lineColorConfig[
                        disruptions[order].line.code.includes("LRT")
                          ? "LRT"
                          : disruptions[order].line.code
                      ].lastStation
                }`}
              </Box>
              <Box className="vert_disruption__line-image-container">
                <img
                  src={getDisruptionAssetSrc(
                    disruptions[order].fromStation.abbreviation +
                      "-" +
                      disruptions[order].fromStation.code +
                      "-L.png",
                  )}
                  alt={disruptions[order].fromStation.name}
                />
                <img
                  src={getDisruptionAssetSrc(
                    getDirectionImage(
                      disruptions[order].direction,
                      disruptions[order].type,
                      disruptions[order].isAffectingAllStation,
                    ),
                  )}
                  alt={getDirectionImage(disruptions[order].direction)}
                />
                <img
                  src={getDisruptionAssetSrc(
                    disruptions[order].toStation.abbreviation +
                      "-" +
                      disruptions[order].toStation.code +
                      "-L.png",
                  )}
                  alt={disruptions[order].toStation.name}
                />
              </Box>
            </Box>
          )}
        </Box>
      </Box>
      <Box className="vert_disruption__bottom-container">
        <Box sx={{ width: "100%" }}>
          <Box>Scan For Train Updates</Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              pt: "2cqw",
            }}
          >
            <Box
              sx={{
                width: "13cqw",
                height: "13cqw",
                backgroundColor: "white",
              }}
            >
              <img
                alt="LTA_Trains_QR"
                style={{ width: "13cqw", height: "13cqw" }}
                src="https://bplrt-api.itxcast.com/api/asset/LTA_Trains_QR_v1.png/file"
              />
            </Box>
          </Box>
        </Box>
        <Box sx={{ width: "100%", pt: "2cqw" }}>
          We apologise for any inconvenience caused
        </Box>
      </Box>
    </Box>
  );
};

export default VerticalPreview;
